import React, { useEffect } from 'react'
import bannerImage from '../images/bannerImg2.png'
import BannerSlider from './BannerSlider'
import TutorialVideo from '../images/tutorialvideo.svg'
import Discussoion from '../images/Discussion_forum.svg';
import PractiseQuize from '../images/Practise_quizz.svg';
import Learning from '../images/Learning_Material.svg';
import Guidence from '../images/Guidences.svg';
import WhoGood from '../images/who_good211.png';
import { useNavigate } from 'react-router-dom';
import RoadSignsIcon from '../images/road-signs.svg';
import ParkingIcon from '../images/parking.svg';
import TrafficRulesIcon from '../images/traffic-rules.svg';
import HighwayDrivingIcon from '../images/highway.svg';
import EmergencyBrakingIcon from '../images/braking.svg';
import NightDrivingIcon from '../images/night-driving.svg';
import LaneChangingIcon from '../images/lane-changing.svg';
import DefensiveDrivingIcon from '../images/defensive-driving.svg';
import FeaturedPrograms from './FeaturedPrograms';
import WhatDoYouGet from './WhatDoYouGet';
import WhatSayAbout from './WhatSayAbout';

function MainPage() {

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* banner section star */}
            <section class="banner">
                <div class="container">
                    <div class="bannerbg">
                        <div class="row align-items-center">
                            <div class="col-md-6 col-lg-7">
                                <BannerSlider />
                            </div>
                            <div class="col-md-6 col-lg-5 mt-3 ">
                                {/* <img src={bannerImage} alt="" class="bannerimg" /> */}
                                <section id="featuredSection">
                                    <FeaturedPrograms />
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Featured Programs section */}


            {/* What do you get section start */}
            
                <WhatDoYouGet />
           



            {/* Featured section start */}
            <section class="tech">
                <div class="container">
                    <div class="heading mb-5 pb-md-3">
                        <h4>Driving Topics We Teach</h4>
                        <p>We offer a variety of driving lessons designed for all levels, from beginners to advanced drivers. Our materials cover essential driving skills, road safety, and traffic rules.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="gallery-wrapper">
                            <div class="marquee">
                                <div class="marquee-content left">
                                    <div class="box">
                                        <img src={RoadSignsIcon} alt="" />
                                        <div>
                                            <h5>Road Signs</h5>
                                            <p>Understand essential traffic signs and their meanings.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={ParkingIcon} alt="" />
                                        <div>
                                            <h5>Parking Techniques</h5>
                                            <p>Master parallel, angle, and perpendicular parking.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={TrafficRulesIcon} alt="" />
                                        <div>
                                            <h5>Traffic Rules</h5>
                                            <p>Learn road regulations for safe and legal driving.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={HighwayDrivingIcon} alt="" />
                                        <div>
                                            <h5>Highway Driving</h5>
                                            <p>Understand merging, lane discipline, and speed limits.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={RoadSignsIcon} alt="" />
                                        <div>
                                            <h5>Road Signs</h5>
                                            <p>Understand essential traffic signs and their meanings.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={ParkingIcon} alt="" />
                                        <div>
                                            <h5>Parking Techniques</h5>
                                            <p>Master parallel, angle, and perpendicular parking.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={TrafficRulesIcon} alt="" />
                                        <div>
                                            <h5>Traffic Rules</h5>
                                            <p>Learn road regulations for safe and legal driving.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={HighwayDrivingIcon} alt="" />
                                        <div>
                                            <h5>Highway Driving</h5>
                                            <p>Understand merging, lane discipline, and speed limits.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="marquee">
                                <div class="marquee-content right">
                                    <div class="box">
                                        <img src={EmergencyBrakingIcon} alt="" />
                                        <div>
                                            <h5>Emergency Braking</h5>
                                            <p>Learn how to react to sudden stops safely.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={NightDrivingIcon} alt="" />
                                        <div>
                                            <h5>Night Driving</h5>
                                            <p>Techniques for safe driving in low visibility conditions.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={LaneChangingIcon} alt="" />
                                        <div>
                                            <h5>Lane Changing</h5>
                                            <p>Proper techniques for smooth and safe lane transitions.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={DefensiveDrivingIcon} alt="" />
                                        <div>
                                            <h5>Defensive Driving</h5>
                                            <p>Strategies to anticipate hazards and avoid accidents.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={EmergencyBrakingIcon} alt="" />
                                        <div>
                                            <h5>Emergency Braking</h5>
                                            <p>Learn how to react to sudden stops safely.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={NightDrivingIcon} alt="" />
                                        <div>
                                            <h5>Night Driving</h5>
                                            <p>Techniques for safe driving in low visibility conditions.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={LaneChangingIcon} alt="" />
                                        <div>
                                            <h5>Lane Changing</h5>
                                            <p>Proper techniques for smooth and safe lane transitions.</p>
                                        </div>
                                    </div>
                                    <div class="box">
                                        <img src={DefensiveDrivingIcon} alt="" />
                                        <div>
                                            <h5>Defensive Driving</h5>
                                            <p>Strategies to anticipate hazards and avoid accidents.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Who is good section start */}
            <section class="who_is_good">
                <div class="container">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-lg-6 mb-3 mb-md-0">
                            <div>
                                <img src={WhoGood} alt="" />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="content">
                                <div class="mb-3 mb-md-5">
                                    <h4>Who is <span>Confident Driver</span> Good for?</h4>
                                    <p class="w-100">Confident Driver is an online learning platform specifically designed to help you learn driving easily, enjoyably, and effectively.</p>
                                </div>

                                <div class="text">
                                    <div>
                                        <span>1</span>
                                    </div>
                                    <h6>Students who want to improve their driving skills and confidently pass their driving tests.</h6>
                                </div>
                                <div class="text">
                                    <div>
                                        <span>2</span>
                                    </div>
                                    <h6>Students who want to prepare for driving license exams and road safety assessments.</h6>
                                </div>
                                <div class="text">
                                    <div>
                                        <span>3</span>
                                    </div>
                                    <h6>Students who want to prepare for their driving theory and practical exams.</h6>
                                </div>
                                <div class="text">
                                    <div>
                                        <span>4</span>
                                    </div>
                                    <h6>Students who have a strong interest and passion for safe and skilled driving.</h6>
                                </div>
                                <div class="text">
                                    <div>
                                        <span>5</span>
                                    </div>
                                    <h6>Students who want to refresh and relearn essential driving rules and techniques.</h6>
                                </div>
                                <button className="btn1" onClick={() => document.getElementById('featuredSection').scrollIntoView({ behavior: 'smooth' })}>
                                    Get Started
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* what say about section start */}
          
                <WhatSayAbout/>
          

            {/* what say about section end */}

            {/* information section start */}
            <section class="information">
                <div class="container">
                    <div class="row justify-content-between">
                        <div class="col-md-5 mb-4 mb-md-0">
                            <div>
                                <h4>Don't miss any information from us!</h4>
                                <p>Sign up to our regular newsletter for news, insights, new product releases & more.</p>
                                <div class="d-flex mt-3 mb-3 mt-md-5 mb-md-3 ">
                                    <div class="position-relative me-3">
                                        <input type="text" placeholder="Input email address" class="form-control" />
                                        <i class="fa-regular fa-envelope"></i>
                                    </div>
                                    <button class="btn1">Subscribe</button>
                                </div>
                                <h6>By subscribing, you agree to our Privacy Policy and consent to receive updates from our
                                    company.</h6>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3 mb-md-5">
                                <h5>About Learning to Drive with Us!</h5>
                                <p class="w-100">Have questions about learning to drive? Our team is here to help! Here are some frequently asked questions about our driving lessons:</p>
                            </div>
                            <div class="accordion custom-accordion" id="faqAccordion">
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="false">
                                            Which driving course is right for me?
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#faqAccordion"
                                    >
                                        <div class="accordion-body">
                                            We offer courses for beginners, intermediate, and advanced drivers. You can take our assessment quiz to find the best course for you.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwo">
                                            How do I enroll in driving lessons?
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div class="accordion-body">
                                            Simply sign up on our website, select your preferred course, and schedule your lessons with our certified instructors.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree">
                                            Is there a fee for the driving lessons?
                                        </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div class="accordion-body">
                                            Yes, our courses have different pricing plans based on the number of sessions and type of training. We also offer package discounts.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseFour">
                                            What topics are covered in the lessons?
                                        </button>
                                    </h2>
                                    <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div class="accordion-body">
                                            Our lessons cover road signs, traffic laws, parking techniques, highway driving, defensive driving, and test preparation.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseFive">
                                            Are the instructors certified?
                                        </button>
                                    </h2>
                                    <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div class="accordion-body">
                                            Yes, all our instructors are certified professionals with years of experience in teaching driving skills safely and effectively.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseSix">
                                            Will this course help me pass my driving test?
                                        </button>
                                    </h2>
                                    <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div class="accordion-body">
                                            Absolutely! We provide practice tests, real-world driving scenarios, and expert guidance to help you pass your driving test with confidence.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseSeven">
                                            Do you offer advanced driving courses?
                                        </button>
                                    </h2>
                                    <div id="collapseSeven" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div class="accordion-body">
                                            Yes, we offer advanced courses for defensive driving, highway driving, and night driving to help you become a skilled and confident driver.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* information section end */}

        </>
    )
}

export default MainPage